/* Stay Sharp SkateLedger landing: scroll reveals, income ring, step highlight, hero parallax.
   Everything is skipped when the visitor prefers reduced motion; the page is complete without it. */
(function () {
  var root = document.getElementById('skateledger');
  if (!root) return;

  /* Keep the section links below the store header when that header is sticky. */
  function placeSubnav() {
    var header = document.querySelector('#header-group .header-section') || document.querySelector('#header-group > *');
    var top = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = header.getBoundingClientRect().height;
    }
    root.style.setProperty('--sl-sticky-top', top + 'px');
  }
  placeSubnav();
  window.addEventListener('resize', placeSubnav);

  /* Highlight the current section in the sticky links (no motion involved). */
  var links = root.querySelectorAll('.sl-subnav__links a');
  if ('IntersectionObserver' in window && links.length) {
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var navObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('is-active'); });
        if (byId[e.target.id]) byId[e.target.id].classList.add('is-active');
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(byId).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) navObserver.observe(el);
    });
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;
  root.classList.add('is-motion');

  /* One-time "in view" flags for reveals, the ring, the steps rail and the hero tap echo. */
  var once = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      once.unobserve(e.target);
      var count = e.target.querySelector('[data-sl-count]');
      if (count) countUp(count);
    });
  }, { threshold: 0.25 });
  root.querySelectorAll('.sl-reveal, [data-sl-ring], [data-sl-steps], .sl-hero').forEach(function (el) { once.observe(el); });

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-sl-count'));
    var start = performance.now();
    var duration = 1300;
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt.format(target * eased);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Section 01: as each point reaches the middle of the screen, its phone steps forward. */
  var wide = window.matchMedia('(min-width: 768px)');
  root.querySelectorAll('[data-sl-points]').forEach(function (list) {
    var section = list.closest('.sl-section');
    var stage = section && section.querySelector('.sl-stage');
    if (!stage) return;
    var items = list.querySelectorAll('li[data-step]');
    var phones = stage.querySelectorAll('.sl-phone[data-step]');
    function setStep(step) {
      items.forEach(function (li) { li.classList.toggle('is-active', li.getAttribute('data-step') === step); });
      phones.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-step') === step); });
    }
    var tracker = new IntersectionObserver(function (entries) {
      if (!wide.matches) return;
      entries.forEach(function (e) {
        if (e.isIntersecting) setStep(e.target.getAttribute('data-step'));
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (li) { tracker.observe(li); });

    var active = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var on = e.isIntersecting && wide.matches;
        list.classList.toggle('is-tracking', on);
        stage.classList.toggle('is-tracking', on);
        if (on && !list.querySelector('li.is-active')) setStep('0');
      });
    }, { threshold: 0.35 });
    active.observe(section);
  });

  /* Hero parallax: side phones drift up to 16px, photo moves at 0.9x. */
  var hero = root.querySelector('.sl-hero');
  var photo = hero && hero.querySelector('.sl-hero__photo');
  var sides = hero ? hero.querySelectorAll('[data-depth]') : [];
  var ticking = false;
  function parallax() {
    ticking = false;
    var rect = hero.getBoundingClientRect();
    if (rect.bottom < 0) return;
    var p = Math.max(0, Math.min(1, -rect.top / rect.height));
    if (photo) photo.style.transform = 'translateY(' + (p * rect.height * 0.1).toFixed(1) + 'px)';
    sides.forEach(function (el) {
      var d = parseFloat(el.getAttribute('data-depth'));
      el.style.transform = 'translateY(' + (p * 32 * d - 0).toFixed(1) + 'px)';
    });
  }
  if (hero) {
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(parallax); }
    }, { passive: true });
  }

  /* If the visitor turns on Reduce Motion mid-visit, drop back to the static page. */
  reduce.addEventListener && reduce.addEventListener('change', function (e) {
    if (e.matches) {
      root.classList.remove('is-motion');
      if (photo) photo.style.transform = '';
      sides.forEach(function (el) { el.style.transform = ''; });
    }
  });
})();
